export const aciLocation = {
    iconName: 'location',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: [
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M4.949 9.783a1.5 1.5 0 00-.3 2.356l8.213 8.213a1.5 1.5 0 002.356-.3 7.521 7.521 0 00.81-5.54l6.529-4.155a1.5 1.5 0 00.256-2.326L16.97 2.188a1.5 1.5 0 00-2.326.255l-4.155 6.53a7.522 7.522 0 00-5.54.81z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M8.753 16.246L.75 24.25',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
